import { render, staticRenderFns } from "./TeamDefaults.vue?vue&type=template&id=270bdb2c&"
import script from "./TeamDefaults.vue?vue&type=script&lang=js&"
export * from "./TeamDefaults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports